export const planProgressPercent = (
  currentValue: number | null | undefined,
  targetValue: number | null | undefined,
): number | null => {
  if (currentValue == null || !targetValue) return null
  return Math.min(100, Math.max(0, Math.round((currentValue / targetValue) * 100)))
}

export const formatPlanProgress = (
  currentValue: number | null | undefined,
  targetValue: number | null | undefined,
  unitName?: string | null,
): string => {
  if (currentValue == null) return 'Not tracked'
  const target = targetValue == null ? '—' : targetValue.toLocaleString('en-GB')
  return `${currentValue.toLocaleString('en-GB')} / ${target}${unitName ? ` ${unitName}` : ''}`
}
